import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  deleteToken,
  onMessage,
} from 'firebase/messaging';
import { getFirestore, collection, addDoc } from 'firebase/firestore';

// Firebase konfiguracija
const config = {
  apiKey: 'AIzaSyC5e4d7IGAY9gvGTiw94fJQhPB8R-LkMhU',
  authDomain: 'myinmoldchat-f676c.firebaseapp.com',
  projectId: 'myinmoldchat-f676c',
  storageBucket: 'myinmoldchat-f676c.appspot.com',
  messagingSenderId: '451581262822',
  appId: '1:451581262822:android:5d4fd92846e49ea791b427',
};

// Inicijalizacija Firebase aplikacije
export const app = initializeApp(config);
export const messagingOn = getMessaging(app);

let serviceWorkerRegistration = null;

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/firebase-messaging.js`)
    .then((registration) => {
      serviceWorkerRegistration = registration;
      console.log('Service Worker registrovan sa opsegom:', registration.scope);
    })
    .catch((error) =>
      console.error('Greška prilikom registracije Service Workera:', error),
    );
}

export const deleteFirebaseToken = async () => {
  try {
    if (serviceWorkerRegistration) {
      await deleteToken(messagingOn, {
        vapidKey:
          'BMciBZpwazhqvLgvIPkCV3Qs37JD9DqLquNJ2fITzHVnWDh36OKKDPQ0bP09gNbDCzGFsCV2Drqa20RegaHoA14',

        serviceWorkerRegistration,
      });
      console.log('FCM token uspešno obrisan.');
    } else {
      console.warn(
        'Service Worker nije registrovan. Token nije moguće obrisati.',
      );
    }
  } catch (error) {
    console.error('Greška prilikom brisanja FCM tokena:', error);
  }
};

export const requestPermissionAndGetToken = async () => {
  try {
    const token = await getToken(messagingOn, {
      vapidKey:
        'BMciBZpwazhqvLgvIPkCV3Qs37JD9DqLquNJ2fITzHVnWDh36OKKDPQ0bP09gNbDCzGFsCV2Drqa20RegaHoA14',
      serviceWorkerRegistration,
    });
    console.log('Firebase token:', token);
    return token;
  } catch (error) {
    console.error('Greška prilikom dobijanja tokena:', error);
    return null;
  }
};

// Funkcija za osluškivanje poruka dok je aplikacija aktivna
export const onMessageListener = (callback) => {
  onMessage(messagingOn, callback);
};

// referenca ka bazi
export const db = getFirestore();
// referenca ka kolekciji (tabeli)
export const collectionRef = collection(db, 'notifications');
// dodavanje podataka u kolekciju
export const addData = (data) => addDoc(collectionRef, { ...data });
// Uklanjanje prethodno registrovanih Service Workera (opciono)
